module.exports = "/packs/media/images/guaranteed-income-chart-93539190e378173c66e8aa678d1933a5.png";